module.exports = {"height":424,"width":1280,"type":"jpg"}